import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ButtonGroup } from "../../elements/CTA";
import M from "materialize-css";

//import { Header } from "../../components/Header";
import Header from "../../components/Header/HeaderBJ";
import { NavBar } from "../../components/NavBar";
// import HorizontalPlayer from "./components/HorizontalPlayer/HorizontalPlayer";
import PlayerHorizontal from "../../components/PlayerHorizontalComponent";
import { Container } from "../../screens/Main/styles";
import ModalRestrationLogin from "../../components/ModalRestrationLogin/ModalRestrationLogin";
import Rodape from "../../components/Rodape/Rodape";
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";

const PLAYER_VISIBLE = "playerVisible";

class layout extends Component {
  constructor(props) {
    super(props);
    let playerVisible = localStorage.getItem(PLAYER_VISIBLE)
      ? JSON.parse(localStorage.getItem(PLAYER_VISIBLE))
      : { visibility: true };
    this.state = {
      mostraPlayer: playerVisible.visibility,
    };
  }

  componentDidMount() {
    //console.log("TAGS: PROPS: ", window)
    window.gtag("config", 'G-6VP0875DQD',  { 
      page_title : window.location.pathname , 
      page_path : window.location.pathname });
    window.gtag("config", 'G-LNVZMYDN5E',  { 
      page_title : window.location.pathname , 
      page_path : window.location.pathname });
    
    var sidenav = document.querySelectorAll(".sidenav");
    var instancesSide = M.Sidenav.init(sidenav, { edge: "right" });
  }
  showHorizontalPlayer = () => {
    let toggle = !this.state.mostraPlayer;
    this.setState(
      {
        mostraPlayer: toggle,
      },
      () =>
        localStorage.setItem(
          PLAYER_VISIBLE,
          JSON.stringify({ visibility: toggle })
        )
    );
  };
  render() {
    //GOOGLE ANALITCS
    ReactGA.initialize([
      {
        trackingId: 'UA-10912487-1',
        gaOptions: { name: 'tracker1' }
      },
      {
        trackingId: 'UA-12962565-11',
        gaOptions: { name: 'tracker2' }
      },
      {
        trackingId: 'UA-55691057-14',
        gaOptions: { name: 'tracker3' }
      }
    ]);
    const history = createBrowserHistory();
    ReactGA.set({ page: history.location.pathname }); // Update the user's current page
    ReactGA.pageview(history.location.pathname,['tracker1','tracker2','tracker3']);
    
    //FIM

    const { children } = this.props;

    return (
      <>
        <Header />
        <Container>
          {/* <NavBar /> */}
          {children}
        </Container>
        <PlayerHorizontal
          {...this.props}
          mostraPlayer={this.state.mostraPlayer}
          showHorizontalPlayer={this.showHorizontalPlayer}
        />
        <div id="slide-out2" className="sidenav menu-account-sidenav">
          <ModalRestrationLogin hideModal />
        </div>
        <Container className="rodape-footer">
          <Rodape />
        </Container>
      </>
    );
  }
}

export default layout;
